import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ROOM_BRAND_FEATURE_KEY, RoomBrandState } from "../reducers";

const roomBrandState = createFeatureSelector<RoomBrandState>(
  ROOM_BRAND_FEATURE_KEY
);

export const isLoading = createSelector(
  roomBrandState,
  (state: RoomBrandState) => state.isLoading
);
